/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Sort_Debt_AscInputs */

const vi_customer_sort_debt_asc = /** @type {(inputs: Customer_Sort_Debt_AscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nợ ít nhất`)
};

/**

* @param {Customer_Sort_Debt_AscInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_sort_debt_asc = /** @type {((inputs?: Customer_Sort_Debt_AscInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Sort_Debt_AscInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_sort_debt_asc(inputs)
});